// extracted by mini-css-extract-plugin
module.exports = {"buttonControl":"CoursePackages-tab_buttonControl_1xSa4","subheadingText":"CoursePackages-tab_subheadingText_IXBnM","coursePackageList":"CoursePackages-tab_coursePackageList_26Tfa"};